import {Component, OnInit} from '@angular/core';
import {SettingsService} from '../settings.service';
import {INetworkSettings} from '../settings-types';
import {DateTime} from 'luxon';
import {SystemGlobalsService} from '../../system-globals.service';
import {MdbSelectOption, MdbCompatibleOption, timezoneList, Truth, BooleanTruth, StringTruth} from '../../common/common-types';
import {ToastService} from '../../../../node_modules/ng-uikit-pro-standard';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'settings-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  public settings: INetworkSettings;
  settingsLoaded: boolean = false;
  staffUsers: MdbSelectOption[];
  timezoneList: MdbCompatibleOption[] = timezoneList.sort((a, b) => a.label.localeCompare(b.label));
  isBusySaving: boolean = false;
  launguages: MdbCompatibleOption[] = [{
    "label": "English",
    "value": "english"
  },
    {
      "label": "French",
      "value": "french"
    }]

  expandAllSettings: boolean = BooleanTruth[this.cookieService.get('expandAllSettings')];

  showSystemBillingContact: boolean = this.expandAllSettings;
  showContentLicence: boolean = this.expandAllSettings;
  showTrainingAuditDate: boolean = this.expandAllSettings;
  showModuleExpiry: boolean = this.expandAllSettings;
  showUserProfileControls: boolean = this.expandAllSettings;
  showTimezoneSettings: boolean = this.expandAllSettings;
  showCoverPhoto: boolean = this.expandAllSettings;
  showBrowserColors: boolean = this.expandAllSettings;
  showDefaultTextSize: boolean = this.expandAllSettings;
  showOlteDocs: boolean = this.expandAllSettings;
  showSystemSettings: boolean = this.expandAllSettings;
  showSystemEmail: boolean = this.expandAllSettings;
  showEmail: boolean = this.expandAllSettings;
  showStudentSettings: boolean = this.expandAllSettings;
  showDocManSettings: boolean = this.expandAllSettings;
  showStaffSettings: boolean = this.expandAllSettings;
  showDesktopMessage: boolean = this.expandAllSettings;
  showSupportContacts: boolean = this.expandAllSettings;
  showLanguage: boolean = this.expandAllSettings;

  constructor(private settingsService: SettingsService, public globals: SystemGlobalsService, private toast: ToastService, private cookieService: CookieService) {
    this.staffUsers = [];
  }

  reloadSettings(settings: INetworkSettings) {
    this.settings = settings;

    // Create staff user options
    this.staffUsers = this.settings.Staff.map(function (user) {
      return new MdbSelectOption(user.name, user.email);
    });

    if (this.settings.Network.default_replyTo_address != null && this.settings.Network.default_replyTo_address.length > 0) {
      this.staffUsers.push(new MdbSelectOption('Custom Recipient', this.settings.Network.default_replyTo_address));
    }

    // Convert dates
    this.settings.Network.training_audit_date = this.settings.Network.training_audit_date.length > 0 && +this.settings.Network.training_audit_date.substring(0, 4) > 1980 ? DateTime.fromSQL(this.settings.Network.training_audit_date).toFormat('dd LLL yyyy') : '';

    // Convert encoded JSON
    this.settings.Network.settings = JSON.parse(this.settings.Network.settings);

    // Convert browser colors
    try {
      let browserColors = JSON.parse(this.settings.Network.browserColors);

      this.settings.Network.browserColors = browserColors;
    } catch (e) {
      var _temp;

      eval('_temp = ' + this.settings.Network.browserColors);
      this.settings.Network.browserColors = _temp;
    }

    if (typeof this.settings.Network.settings['enableManagerFeed'] == undefined) {
      this.settings.Network.settings['enableManagerFeed'] = false;
    }
    if (typeof this.settings.Network.settings['managerFeed'] == undefined) {
      this.settings.Network.settings['managerFeed'] = '';
    }
    if (typeof this.settings.Network.settings['managerFeedName'] == undefined) {
      this.settings.Network.settings['managerFeedName'] = 'Training Plan';
    }
    if (this.settings.Network.settings['useNewTrainingUI'] == undefined) {
      this.settings.Network.settings['useNewTrainingUI'] = true;
    }
    if (this.settings.Network.settings['disableGeneralManagerNotifications'] == undefined) {
      this.settings.Network.settings['disableGeneralManagerNotifications'] = false;
    }

    if (this.settings.Network.settings['replyToSupportEmail'] == undefined) {
      this.settings.Network.settings['replyToSupportEmail'] = true;
    }

    if (this.settings.Network.settings['supportContact'] == undefined) this.settings.Network.settings['supportContact'] = [];
    if (this.settings.Network.settings['allowStaffPreviewModules'] == undefined) this.settings.Network.settings['allowStaffPreviewModules'] = true;
    if (this.settings.Network.settings['showModuleValidUntil'] == undefined) this.settings.Network.settings['showModuleValidUntil'] = false;

    if (this.settings.Network.settings['documentManagerVisibility'] == undefined) {
      this.settings.Network.settings['documentManagerVisibility'] = {
        2: true,
        3: true,
        4: true,
        5: true,
        6: true,
        7: false,
        8: false,
        16: false,
      };
    }

    this.settingsLoaded = true;
  }

  getSettings() {
    this.settingsService.getSettings().subscribe(settings => this.reloadSettings(settings));
  }

  setDefaultColors() {
    this.settings.Network.browserColors['menuBackground'] = '#171919';
    this.settings.Network.browserColors['pageMenuText'] = '#171919';
    this.settings.Network.browserColors['menuText'] = '#FFFFFF';
    this.settings.Network.browserColors['highlight'] = '#004300';
  }

  saveSettings() {
    this.isBusySaving = true;

    let settingsData = JSON.parse(JSON.stringify(this.settings));

    // Convert date
    settingsData.Network.training_audit_date = DateTime.fromFormat(this.settings.Network.training_audit_date, 'dd LLL yyyy').toSQLDate();

    // Re-encode JSON settings
    settingsData.Network.settings = JSON.stringify(this.settings.Network.settings);

    // Re-encode browser colors
    settingsData.Network.browserColors = JSON.stringify(this.settings.Network.browserColors);

    this.settingsService.saveSettings(settingsData).subscribe(
      () => {
        this.isBusySaving = false;
        this.toast.info('Saved learning center settings', 'Success', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      },
      error => {
        this.isBusySaving = false;
        this.toast.error(error, 'Error', {positionClass: 'md-toast-bottom-right', toastClass: 'opaque'});
      }
    );
  }

  addSupportContact() {
    this.settings.Network.settings['supportContact'].push({
      name: '',
      email: '',
      phone: ''
    });
  }

  removeSupportContact(index: number) {
    this.settings.Network.settings['supportContact'].splice(index, 1);
  }

  ngOnInit() {
    this.getSettings();
  }

  toggleSettings() {
    this.cookieService.set('expandAllSettings', this.expandAllSettings ? StringTruth.true : StringTruth.false);

    this.showSystemBillingContact = this.expandAllSettings;
    this.showContentLicence = this.expandAllSettings;
    this.showTrainingAuditDate = this.expandAllSettings;
    this.showModuleExpiry = this.expandAllSettings;
    this.showUserProfileControls = this.expandAllSettings;
    this.showTimezoneSettings = this.expandAllSettings;
    this.showCoverPhoto = this.expandAllSettings;
    this.showBrowserColors = this.expandAllSettings;
    this.showDefaultTextSize = this.expandAllSettings;
    this.showOlteDocs = this.expandAllSettings;
    this.showSystemSettings = this.expandAllSettings;
    this.showSystemEmail = this.expandAllSettings;
    this.showEmail = this.expandAllSettings;
    this.showStudentSettings = this.expandAllSettings;
    this.showDocManSettings = this.expandAllSettings;
    this.showStaffSettings = this.expandAllSettings;
  }

  protected featureEnabled() {
    return this.globals.constants.features && this.globals.constants.features.checklist;
  }
}
